import React from "react";
import Layout from "../../components/Layout";
import * as S from "./styles";
import { imageApi, getContainDimensions } from "../../helpers";
import ImageWPlaceholder from "../../components/ImageWPlaceholder";

class Download extends React.Component {
  state = {
    width: "auto",
  };
  componentDidMount() {
    window.addEventListener("resize", this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    if (!this.props.thumbnail) return;
    const src = this.props.thumbnail;
    const containerRect = this._container.getBoundingClientRect();
    const aspect = src.width / src.height;
    const maxHeight = Math.min(1600, Math.max(500, window.innerHeight * 0.6));
    const dimens = getContainDimensions(aspect, containerRect.width, maxHeight);
    const width = dimens.width + "px";
    this.setState({
      width,
    });
  };

  render() {
    const { thumbnail, title, download } = this.props;
    const isPortrait = thumbnail && thumbnail.height > thumbnail.width;
    const image = thumbnail && imageApi(thumbnail, { fixWidth: 1200 });
    const wrapperStyle = {
      width: this.state.width,
    };
    return (
      <S.Work
        portrait={isPortrait}
        ref={(c) => {
          this._container = c;
        }}
      >
        <S.ImageSizer style={wrapperStyle}>
          {!!image && (
            <a href={download} download>
              <ImageWPlaceholder {...image} />
            </a>
          )}
          <S.WorkInfo>
            <div>{title}</div>
            {!!download && (
              <S.DownloadLink>
                <a href={download} download>
                  Download Hi-Res
                </a>
              </S.DownloadLink>
            )}
          </S.WorkInfo>
        </S.ImageSizer>
      </S.Work>
    );
  }
}

const Downloads = ({ downloads }) => {
  console.log(downloads);
  return (
    <Layout>
      <S.Title>
        <div>Downloads</div>
      </S.Title>
      <S.WorksList>
        {downloads.map((o, i) => (
          <Download {...o} key={i} />
        ))}
      </S.WorksList>
    </Layout>
  );
};

export default Downloads;
